import * as React from "react";
import styled, { css } from "styled-components";

import Grid from "src/library/components/Hedron";
import { Icon } from "src/library/components/Icon";
import { Link } from "src/library/components/Link";
import { Text } from "src/library/components/Text";
import { breakpoint } from "src/library/utils/styled-media-queries";
import { Colors } from "src/library/utils/theme";
import { Icons } from "src/library/components/Icon/types";

interface IProps {
  IconComponent: React.ReactFCWithChildren;
  text: string;
  total: number;
  action: { text: string; to: string; onClick?: () => void };
  background: keyof Colors;
}

const OrdersWeekIconSummary: React.ReactFCWithChildren<IProps> = ({
  IconComponent, total, text, action, background
}) => {
  return (
    <OrdersWeekIconSummaryWrapper
      direction="horizontal"
      background={background}
      allowWrap
    >
      <Grid.Box className="icon-wrapper">
        <IconComponent />
      </Grid.Box>

      <Grid.Bounds direction="vertical">
        <Text
          weight="bold"
          fontSize="h1"
        >
          {total}
        </Text>

        <Text
          weight="bold"
          color="secondary"
          fontSize="sub"
          textTransform="uppercase"
        >
          {text}
        </Text>

        {action.onClick && typeof action.onClick === "function" ? (
          <Text
            onClick={action.onClick}
            className="view-wrapper"
          >
            <>
              {action.text}

              {" "}

              <Icon
                $fillColor="primaryLight"
                className="view-icon"
                icon={Icons.CHEVRONRIGHT}
              />
            </>
          </Text>
        ) : (
          <Link
            to={action.to}
            className="view-wrapper"
          >
            <>
              {action.text}

              {" "}

              <Icon
                $fillColor="primaryLight"
                className="view-icon"
                icon={Icons.CHEVRONRIGHT}
              />
            </>
          </Link>
        )}
      </Grid.Bounds>
    </OrdersWeekIconSummaryWrapper>
  );
};

export default OrdersWeekIconSummary;

const OrdersWeekIconSummaryWrapper = styled(Grid.Bounds)<{ background: keyof Colors }>`
  ${({ theme, background }) => css`
    width: 100%;
    ${breakpoint("md", theme)} {
      width: auto;
    }

    margin-right: ${theme.spacing.margins.md};
    margin-bottom: ${theme.spacing.margins.lg};

    .icon-wrapper {
      margin: ${theme.spacing.margins.sm};
      border-radius: 50%;
      width: 40px;
      height: 40px;
      background: ${theme.colors[ background ]};
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        opacity: 0.7;
      }
    }

    .view-wrapper {
      position: relative;
      display: block;
      margin-top: ${theme.spacing.margins.sm};
      padding-right: calc(25px + ${theme.spacing.padding.sm});
      cursor: pointer;

      :hover {
        .view-icon {
          right: 5px;
        }
      }

      .view-icon {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  `};
`;
